import createReactComponent from '../createReactComponent';
export default createReactComponent('clock-hand', 'ClockHand', [["path",{"d":"M12.147 3v9l6 3","key":"svg-0"}]]);